import { useCallback, RefObject } from "react";
import Webcam from "react-webcam";
import { cameraFailedToReadBarcodeError } from "../helpers/scannerSentryErrorHandlerUtils";

export type ScanResult = { barcode: string; format: string };

type UseGenericDetectBarcodeProps = {
  isVideoReady: boolean;
  webcamRef: RefObject<Webcam | null>;
  onDetected: (scanResult: ScanResult) => void;
};

export function useDetectBarcode({
  isVideoReady,
  webcamRef,
  onDetected,
}: UseGenericDetectBarcodeProps) {
  return useCallback(async () => {
    if (!("BarcodeDetector" in window)) return;
    if (!isVideoReady) return;
    const video = webcamRef.current?.video;
    if (!video) return;
    if (video.readyState !== HTMLMediaElement.HAVE_ENOUGH_DATA) return;
    try {
      const detector = new BarcodeDetector({
        formats: ["itf", "data_matrix", "ean_13"],
      });
      const barcodes = await detector.detect(video);
      if (barcodes && barcodes.length > 0) {
        onDetected({
          barcode: barcodes[0]?.rawValue ?? "",
          format: barcodes[0]?.format ?? "",
        });
      }
    } catch (error: unknown) {
      cameraFailedToReadBarcodeError(error);
    }
  }, [isVideoReady, webcamRef, onDetected]);
}
